import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';

export enum eSortOptions {
  FREQUENCY_AND_TRAVEL_TIME,
  SHORTEST_TIME,
  FEWEST_WALK_TIME,
  FEWEST_STATION_SWITCH,
}

export const SORT_OPTIONS: SelectOption<eSortOptions>[] = [
  {
    label: 'שקלול של תדירות וזמן נסיעה',
    value: eSortOptions.FREQUENCY_AND_TRAVEL_TIME,
  },
  {
    label: 'זמן מהיר ביותר למסלול',
    value: eSortOptions.SHORTEST_TIME,
  },
  {
    label: 'הכי מעט זמן הליכה',
    value: eSortOptions.FEWEST_WALK_TIME,
  },
  {
    label: 'הכי מעט החלפות',
    value: eSortOptions.FEWEST_STATION_SWITCH,
  },
];
